import { useState } from 'react'
import { message as $message } from 'antd'
import { queryShelvesStatistics } from '@/services/goods'

// hack：平台资料 useActivate 执行两次的问题
let isFetching = false

export default () => {
    const [shelvesRateData, setShelvesRateData] = useState(null)

    const loadShelvesRateData = async () => {
        if (isFetching) {
            return
        }

        isFetching = true

        try {
            const { success, message, data } = await queryShelvesStatistics()

            if (success) {
                setShelvesRateData(data)
            } else {
                setShelvesRateData(null)
                $message.error(message)
            }
        } catch (e) {
            console.error(e)
            setShelvesRateData(null)
        }

        isFetching = false
    }

    return {
        shelvesRateData,
        loadShelvesRateData,
    }
}
